import adnBannerImage from 'pages/Welcome/Resources/images/1-banner.png';
import adnCardImage from 'pages/Welcome/Resources/images/1-card.png';
import familyBannerImage from 'pages/Welcome/Resources/images/2-banner.png';
import familyCardImage from 'pages/Welcome/Resources/images/2-card.png';
import heartContentImage from 'pages/Welcome/Resources/images/2-content.png';
import DoctorCardImage from 'pages/Welcome/Resources/images/3-card.png';
import DoctorBannerImage from 'pages/Welcome/Resources/images/3-banner.png';
import PatientJourneyImage from 'pages/Welcome/Resources/images/4-card.png';
import PatientJourneyBannerImage from 'pages/Welcome/Resources/images/4-banner.png';
import DiscoveryImage from 'pages/Welcome/Resources/images/4-discovery.png';
import DefectImage from 'pages/Welcome/Resources/images/4-defects.png';
import SnapShotImage from 'pages/Welcome/Resources/images/4-snapshot.png';
import AuthorImage from 'pages/Welcome/Resources/images/4-author.png';
import AvLogo from 'pages/Welcome/Resources/images/AvLogo.png';
import CardImage from 'pages/Welcome/Resources/images/5-Card.jpg';
import Question1 from 'pages/Welcome/Resources/images/Question1.png';
import Question2 from 'pages/Welcome/Resources/images/Question2.png';
import Question3 from 'pages/Welcome/Resources/images/Question3.png';
import Question4 from 'pages/Welcome/Resources/images/Question4.png';
import Question5 from 'pages/Welcome/Resources/images/Question5.png';
import Question6 from 'pages/Welcome/Resources/images/Question6.png';
import Question7 from 'pages/Welcome/Resources/images/Question7.png';
import Question8 from 'pages/Welcome/Resources/images/Question8.png';
import Question9 from 'pages/Welcome/Resources/images/Question9.png';
import Question10 from 'pages/Welcome/Resources/images/Question10.png';
import Question11 from 'pages/Welcome/Resources/images/Question11.png';
import { Link } from 'react-router-dom';
import VideoPlayer from 'components/VideoPlayer';
import WelcomeImage from 'images/onboarding/welcome.jpg';
import VideoThumbnail from 'images/welcome/Video_thumbnail.jpg'
import { getAssetDomain } from 'config/API';
import { SVSOURCE_CONTACT } from 'utils/constants';
import { Typography } from '@mui/material';

const images = [Question1, Question2, Question3, Question4, Question5, Question6, Question7, Question8, Question9, Question10, Question11];

const videoBaseUrl = getAssetDomain();

const videoElement = (
  <VideoPlayer
    src={`${videoBaseUrl}/av-svs/DrNewburger_Causes.mp4`}
    height={'auto'}
    width={'100%'}
    poster={`${WelcomeImage}`}
    controls
    containerStyle={{
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
      marginTop: '20px',
    }}
  />
);

const videoElement2 = (
  <VideoPlayer
    src={`${videoBaseUrl}/av-svs/FINAL1428_AdditionalVentures_ProjectSource_DrSrivastavaWIP_v03_SC.mp4`}
    height={'auto'}
    width={'100%'}
    poster={`${VideoThumbnail}`}
    controls
    containerStyle={{
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
      marginTop: '20px',
    }}
  />
);
const SectionTitle = ({ number, title }) => (
  <span style={{ marginLeft: '8px' }}>
    {`${number})`} <strong style={{ color: '#000' }}>{title}</strong>
  </span>
);
// Helper for Q&A blocks to reduce duplication
const QASection = ({ qa }) => (
  <>
    {qa.map(({ img, alt, question, answer, imgStyle }, idx) => (
      <>
      <div key={idx} style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img alt={alt} src={img} style={imgStyle ? imgStyle: undefined}/>
          <p style={{ fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '1rem', color: '#011C48' }}>
            <span style={{ color: '#00BC70', fontWeight:'bold' }}>Question:</span> {question}
          </p>
        </div>
        <p style={{ fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '1rem', color: '#011C48', marginTop: '10px' }}>
          <span style={{ color: '#00BC70', fontWeight:'bold' }}>Answer:</span> <span dangerouslySetInnerHTML={{ __html: answer }} />
        </p>
      </div>
      {idx!== qa.length-1 &&(
        <>
          <br />
          <br />
        </>
      )}
    </>
    ))}
  </>
);

export const resourcesContent = {
  pageTitle: 'Resources',
  subTitle: 'Discover a selection of resources and links tailored for you.',
  readMore: 'Read more',
  resources: [
    {
      alt: 'About Additional Ventures, Funder of the SOURCE Study',
      bannerImage: CardImage,
      cardImage: CardImage,
      display: true,
      id: 5,
      displayTitle: false,
      title:
        'About Additional Ventures, Funder of the SOURCE Study',
      blogTitle: 'About Additional Ventures',
      description:
        'About Additional Ventures, Funder of the SOURCE Study If you’re considering joining the SOURCE study ...',
      content: (
        <>
          <Typography variant='h5' mt='16px'>About Additional Ventures, Funder of the SOURCE Study</Typography>
          <br/>
          If you’re considering joining the SOURCE study, you may be wondering who is funding the research. The SOURCE study is staffed and fully paid for by Additional Ventures, a nonprofit foundation that funds single ventricle heart defects research.
          <br/>
          <br/>
          Additional Ventures launched the SOURCE study in December 2024 to help the research community better understand the genetics and biology of single ventricle heart defects. Better understanding single ventricle defects and their complications helps the field improve treatments — and develop new ones — for patients.
          <br/>
          <br/>
          <img
            alt='AVLOGO'
            src={AvLogo}
            width='50%'
            style={{display:'block', margin: '0 auto'}}
          />
          <br/>
          <br/>
          <Typography variant='h5'>Who is Additional Ventures?</Typography>
          <br/>
          Additional Ventures is a nonprofit foundation with a singular mission: to cure single ventricle heart defects through transformative research and strategic investments that revolutionize treatment and care.  The organization is committed to improving care and outcomes for <strong>everyone</strong> living with single ventricle heart defects – those alive today and those born in the future.
          <br/>
          <br/>
          Since its founding in 2019, Additional Ventures has funded more than $100 million in single ventricle heart defects research programs.  As a nonprofit foundation, Additional Ventures does not profit from this work — all funds support its mission.
          <br/>
          <br/>
          <Typography variant='h5'>What does Additional Ventures fund?</Typography>
          <br/>
          Additional Ventures supports research in many ways.
          <br/>
          <br/>
          <SectionTitle number={1} title="Research grant programs" />
          <br/>
          Additional Ventures funds researchers across the United States and around the world who are working to better understand single ventricle heart defects and develop new therapies and devices.
          <br/>
          <br/>
          This includes research into complications such as lymphatic dysfunction, liver disease, heart failure, arrhythmias, and more.
          <br/>
          <br/>
          <SectionTitle number={2} title="The Cures Collaborative" />
          <br/>
          The Cures Collaborative is a multidisciplinary team of investigators across eight institutions focused on a long-term goal: working on tissue engineering approaches that could one day help replace the missing "pump” (or ventricle) in single ventricle heart defects.
          <br/>
          <br/>
          <SectionTitle number={3} title="Translating promising discoveries into real treatments" />
          <br/>
          We support researchers and teams who are advancing new medicines and medical devices for single ventricle patients – providing funding and strategic support to help move promising ideas from the laboratory through development and toward clinical use.
          <br/>
          <br/>
          <SectionTitle number={4} title="Foundational resources for the field" />
          <br/>
          Some of the most important breakthroughs require shared resources — like large datasets — that help researchers ask and answer big questions.   The SOURCE Study is one of these foundational resources.
          <br/>
          <br/>
          Through SOURCE, we are building the world’s largest genomic dataset and providing it free of charge to researchers worldwide.
          <br/>
          <br/>
          <SectionTitle number={5} title="Investments in promising medical technology" />
          <br/>
          We invest in medical technology companies working on devices that may improve outcomes for patients with single ventricle heart defects. Our investments help promising technologies reach patients.
          <br/>
          <br/>
          <SectionTitle number={6} title="Scientific events" />
          <br/>
          We host scientific conferences and other convenings that bring researchers together to share knowledge and ideas and grow the single ventricle heart defect research community.
          <br/>
          <br/>
          <br/>
          <Typography variant='h5'>How does Additional Ventures work to accelerate progress in single ventricle research?</Typography>
          <br/>
          Additional Ventures’ work and priorities are guided by a strategic Research Roadmap and four core principles:
          <br/>
          <ul style={{listStyleType:'disc'}}>
            <li><strong style={{ color: '#000' }}>Impact Focus: </strong> We focus on the areas where we can make the greatest difference in single ventricle heart defect research. </li>
            <li><strong style={{ color: '#000' }}>Urgency: </strong> Patients and families don’t have time to wait for better treatments and improved outcomes, so we move as quickly as possible. </li>
            <li><strong style={{ color: '#000' }}>Collaboration: </strong> Single ventricle heart defects are complex, and solving them requires many partners across many fields. </li>
            <li><strong style={{ color: '#000' }}>Agility: </strong> While our mission remains the same, we adjust our strategy and approach as the science evolves.</li>
          </ul>
          <br/>
          Additional Ventures was founded on the belief that progress and cures for single ventricle heart defects are both necessary <strong>and</strong> possible, with intentional focused effort and adequate investment. Our grant programs, strategic partnerships, and innovative approaches to research – including the SOURCE study – can help bring to life the discoveries needed to cure single ventricle.
          <br/>
          <br/>
          For more information about Additional Ventures, visit <a href='https://www.additionalventures.org/' target='_blank' rel="noreferrer"> www.additionalventures.org</a>.
          <br/>
          <br/>
          To learn more about the SOURCE study, read our <Link target='_blank' to='/welcome/faq'>Frequently Asked Questions</Link>.
        </>
      ),
    },
    {
      alt: 'Patient Journey',
      bannerImage: PatientJourneyBannerImage,
      cardImage: PatientJourneyImage,
      display: true,
      id: 4,
      title:
        'Transforming the Single Ventricle Patient Journey',
      blogTitle: 'Transforming the Single Ventricle Patient Journey by Diane M. Pickles, Director of SOURCE, Additional Ventures',
      description:
        'Thanks to surgical improvements, most infants born with single ventricle heart defects now survive and live into adulthood. But patients still...',
      content: (
        <>
          Thanks to surgical improvements, most infants born with single ventricle heart defects now survive and live into adulthood. But patients still endure multiple cardiac surgeries, a lifetime of specialized medical care, and the lifelong risk of developing complications like liver disease, plastic bronchitis, and heart failure. Despite better survival, the single ventricle journey remains difficult — medically, emotionally, and financially.
          <br />
          <br />
          What if scientists could transform the single ventricle journey to one where each patient has access to treatments customized to their own unique genetics and biology — treatments that would enable every single ventricle patient to survive and thrive?
          <br />
          <br />
          What if scientists could predict which single ventricle patients are at risk for certain complications and develop new, targeted treatments that could either treat those issues or prevent them altogether?
          <br />
          <br />
          What if scientists could not only develop better treatments for single ventricle and its complications, but even develop cures?
          <br />
          <br />
          We believe this future is possible. It’s why Additional Ventures launched Single Ventricle SOURCE: to make this vision a reality.
          <br />
          <br />
          SOURCE is an IRB-approved research study created to catalyze the discovery of new, targeted, transformative treatments and cures for single ventricle heart defects. We will achieve this by building the world’s largest genetic dataset of single ventricle patients and their immediate family members, equipping researchers with the information needed to better understand single ventricle heart defects and related complications.  We have the benefit of building on decades of work done by pioneering surgeons, dedicated researchers, advocacy organizations, and families who have participated in previous research studies.  SOURCE was designed to complement and accelerate these collective efforts.
          <br />
          <br />
          <img
            alt='SOURCE in a snapshot'
            src={SnapShotImage}
            width='100%'
            style={{marginLeft: '-8px'}}
          />
          <br />
          <br />
          Currently, scientists don’t fully understand what causes single ventricle or the many complications that can come along with it. But we do know that genetics play an important role. By studying the DNA (which we collect through a cheek swab) and cardiac medical records of large numbers of single ventricle patients and families, scientists will be able to make these discoveries. And, by understanding the genetics and biology of single ventricle, we will have the critical information needed to develop new treatments that are customized to individual patients and, maybe even cures.
          <br />
          <br />
          Not only are we building this dataset, but we’re also making the deidentified data available free of charge to all qualified researchers worldwide. (“Deidentified” means that no information that could identify participants, such as name or date of birth, will be shared with researchers.) In this way, your participation in SOURCE won’t guide one research study — but many, many research studies that help improve single ventricle care and outcomes.
          <br />
          <br />
          <img
            alt='How SOURCE Turns Data into Discovery'
            src={DiscoveryImage}
            width='100%'
            style={{marginLeft: '-8px'}}
          />
          <br />
          <br />
          At Additional Ventures, we know that patients and their families deserve better than their current reality, and that sound research holds the key to advancing desperately needed new treatments, improved outcomes, and cures. To achieve the future we know is possible — where a single ventricle diagnosis doesn’t determine a person’s length or quality of life, where its causes aren’t a mystery, and where patients have access to treatments and cures customized to their personal genetics and biology — <strong>we need your help</strong>.
          <br />
          <br />
          Single ventricle is complex, but with the right data and enough of it, we can power research that transforms the single ventricle journey. As a single ventricle patient or family member, your participation in SOURCE will help us make this new vision a reality.
          <br/><br/>
          <img
            alt='What are Single Ventricle Heart Defects?'
            src={DefectImage}
            width='100%'
            style={{marginLeft: '-8px'}}
          />
          <br />
          <br />
          Of course, none of this will happen overnight. The road from discovery to treatment is complex, and many promising insights take years — even decades — to reach patients. But we believe it’s essential to begin with bold goals and a clear commitment to making steady, meaningful progress.  And, we are committed to finding new treatments and one day cures for all those with single ventricle – those living with these diseases today as well as those to come in the future.
          <br />
          <br />
          <img
            alt='Author with her son'
            src={AuthorImage}
            width='100%'
            style={{marginLeft: '-8px'}}
          />
          <br/>
          <em>Diane Pickles, Director of SOURCE, and her son Jake, single ventricle (HLHS)</em>
          <br/><br/>
          Visit <a href='http://www.svsource.org' rel='noreferrer' target='_blank'>svsource.org</a> to find out how you can be part of this ground-breaking study and help us transform the single ventricle journey. 
        </>
      ),
    },
    {
      alt: 'Experts',
      bannerImage: DoctorBannerImage,
      cardImage: DoctorCardImage,
      display: true,
      id: 3,
      title: 'Expert Q&A: Genetics, Single Ventricle, and SOURCE',
      description:
        'Patients and families often have important questions about the genetics of single ventricle heart defects – what causes them, how genetics...',
      content: (
        <>
          Patients and families often have important questions about the genetics of single ventricle heart defects – what causes them, how genetics are involved, and how the two may be connected. In this expert Q&A, two specialists in pediatric cardiology and genetics explain what we know about the causes of single ventricle, what genetic testing can (and can’t) tell us, and how SOURCE is different from traditional clinical genetic testing.
          <br />
          <br />
          <b>Expert Answers from:</b>
          <br /><br />
          <b>Jane Newburger, MD, MPH,</b> Associate Chair for Academic Affairs, Department of Cardiology, Boston Children’s Hospital; Commonwealth Professor of Pediatrics, Harvard Medical School
          <br /><br />
          <b>Amy Roberts, MD,</b> Co-Director, Center for Cardiovascular Genetics, Department of Cardiology, Boston Children’s Hospital; Associate Professor of Pediatrics, Harvard Medical School
          <br /><br />
          For a simple summary of this Q&A,{' '}
          <Link to={`/welcome/resources/0`}>click here.</Link>
          <br /><br />
          <QASection qa={[
            {
              img: images[0],
              alt: 'HeartImage',
              question: 'What can we currently say, with certainty, about the causes of single ventricle heart defects?',
              answer: `Single ventricle heart defects develop early during fetal life. We know with certainty that some cases of single ventricle heart defects are caused by genetic variants, defined as a difference from usual in the DNA sequence at a specific location in the genome. Sometimes, single ventricle heart defects can be associated with interactions between genes when there are variants in more than one gene that, together, lead to altered heart development. We also know that non-genetic factors including pregestational maternal diabetes, hypertension, alcohol use, and others play a role as well.<br/><br/>The specific genes known to be involved in causing single ventricle heart defects may depend upon the type of single ventricle defect; for example, the genetic causes of hypoplastic left heart syndrome (HLHS) may be different from those of single ventricle associated with heterotaxy syndrome.<br/><br/>For most cases of single ventricle, the genetic cause is still unknown.<br/><br/>With further research on large numbers of patients, such as in the SOURCE study, we will find the cause of single ventricle heart defects in a much greater percentage of affected individuals.`
            },
            {
              img: images[1],
              alt: 'PlantImage',
              question: 'The goal of SOURCE is to discover what causes single ventricle heart defects. Why is this important? How would it help patients?',
              answer: `Finding the causes of single ventricle heart defects will help patients in many ways.<ul style="list-style-type:disc;"><ul style="list-style-type:disc;"><li>Better understanding of genetic causes will allow doctors to anticipate cardiac problems that might arise in the future, for example worsening heart valve or heart muscle function. This might enable doctors to provide treatment sooner to these patients.</li><li>Knowledge of causes also allows families to learn more about recurrence risks in future pregnancies and, when the genetic variant is carried by one or both parents, to consider options like prenatal genetic testing and in vitro fertilization (IVF).</li><li>Greater knowledge about causes of single ventricle heart defects will also promote new therapies that target specific genes or molecules (chemical substances) in cells to improve long-term survival, medical outcomes, and quality of life.</li></ul><br/>Advances in our understanding of causes of single ventricle heart defects will lead to improved prevention and treatment that will benefit both current and future generations of affected patients.`
            },
            {
              img: images[2],
              alt: 'NurseImage',
              question: 'Some single ventricle families undergo genetic testing after a single ventricle diagnosis. What can genetic testing tell us about single ventricle heart defects? What can’t it tell us?',
              answer: `Genetic testing can tell us about the cause of single ventricle heart defects in some patients. It can inform the medical management of the patient by identifying the prognosis and potential involvement of other organ systems, and it can help predict the risk of recurrence in future pregnancies. It can also tell us about other types of complications for which a patient should undergo medical monitoring, for example neurodevelopmental disabilities, hearing loss, or susceptibility to pneumonia and infections.<br/><br/>Unfortunately, genetic testing cannot yet tell us the cause of single ventricle heart defects in most patients. Further research is needed to discover new genes that cause single ventricle heart defects, as well as causes or contributors that are polygenic (this means the combined effects of different genes) and epigenetic (this means changes in the body that turn genes "on" or "off").<br/><br/>This is why the SOURCE study is so important! By studying very large numbers of patients and their family members and doing what is called whole genome sequencing, we will learn more about the genetic changes that can cause single ventricle heart defects.`
            },
            {
              img: images[3],
              alt: 'NoImage',
              question: 'Families who have had genetic testing sometimes report that the tests were negative for their family. What does a “negative” result actually mean?',
              answer: `A negative result means that clinical genetic testing has not with certainty identified a genetic variation known to be associated with single ventricle heart defects. However, a negative result does NOT exclude the possibility of a genetic cause of the disease. This is because most genetic causes of single ventricle heart defects have not yet been identified.<br/><br/>We continue to discover new genes, and further research involving a very large number of individuals with single ventricle is needed to understand how several genes can interact to cause these defects. It is hoped that with a larger number of individuals affected by single ventricle heart defects participating in genetic studies, we may be able to test more comprehensively for genetic causes in the future. This hope has inspired Additional Ventures to launch the SOURCE study.`
            },
            {
              img: images[4],
              alt: 'DownloadImage',
              question: 'What does it mean if a specific genetic variant associated with single ventricle is identified in genetic testing?',
              answer: `If a specific genetic variant known to be associated with single ventricle is identified, it means that this genetic variant was involved in causing or contributing to the single ventricle heart defect in the patient who was tested. Knowing the specific genetic change that caused a single ventricle heart defect can provide information about associated risks -- for example, difficulty clearing secretions after surgery, developmental problems, or problems with immune function. When we know about a specific genetic variant and its associated risks affecting non-cardiac organ systems, we do more detailed and targeted medical monitoring than usual to be sure that the patient stays as healthy as possible. A confirmed genetic cause also helps us to understand what the risk of recurrence would be for future pregnancies of the parents and of the individual with the single ventricle defect in the future. This allows for options like prenatal genetic testing and in vitro fertilization (IVF).<br/><br/>Currently, genetic testing can only find variants that we know are associated with single ventricle heart defects. In most cases, the genetic causes of single ventricle heart defects are not yet known which means that we can’t test to find those variants. That’s why studies like SOURCE are important.`
            },
            {
              img: images[5],
              alt: 'DNAImage',
              question: 'SOURCE is collecting DNA samples from patients and immediate family members and doing whole genome sequencing. How is this different from genetic testing that patients and families might have done by a doctor?',
              answer: `Genetic tests ordered by doctors have traditionally focused on specific genes or groups of genes that have been proven to be associated with a particular condition. In contrast, whole genome sequencing, which SOURCE is doing, analyzes nearly all of a person's DNA. This includes areas not typically examined in clinical tests, which allows detection of a broader range of genetic variants, including in genes not yet proven to cause disease.<br/><br/>Whole genome sequencing is comprehensive and does not only explore particular genes based upon what is known or thought might be true about a disease. For this reason, it can pick up rare or brand new genetic variants causing single ventricle heart defects that might be missed by clinical testing. Even if the first analysis of genome data does not uncover the genetic cause, another benefit is that the data can be saved and re-analyzed in the future to look for changes in genes discovered since the time of the first analysis.<br/><br/>Whole genome sequencing differs from traditional clinical genetic testing in its scope, comprehensiveness, and ability to detect a wider array of genetic changes. While clinical genetic testing is efficient for known conditions, whole genome sequencing is invaluable for diagnosing complex, rare, or unexplained disorders when other tests and research have failed to yield answers. This is why the SOURCE study is so important for making new discoveries about single ventricle heart defects.`
            },
            {
              img: images[6],
              alt: 'HandsImage',
              question: 'Should patients and family members consider participating in SOURCE if they have had genetic testing, even if they have received a “negative” result or had a genetic variant identified? Why?',
              answer: `Yes! All patients and family members should consider participating in SOURCE, regardless of whether they have previously received a negative result or have been identified as having a genetic variant. Participation in SOURCE can advance scientific knowledge and help uncover new insights for individuals and families.<br/><br/>“Negative” results in clinical genetic testing usually mean that no variants known to be associated with single ventricle heart defects were found. However, only some of the genetic variants that cause single ventricle have been identified to date, many remain to be discovered, and most causes of single ventricle heart defects are still unknown. Thus, a “negative” result does NOT exclude the possibility of a genetic cause of single ventricle in a particular person.<br/><br/>Of note, SOURCE will use whole genome sequencing, which will look at nearly all of the genes rather than just those already known to be connected to single ventricle heart defects. If many participants are discovered to have variants in the same gene, that gene can be added to the list of proven genetic causes of single ventricle, advancing our knowledge of genetic causes of single ventricle heart disease.<br/><br/>To accomplish the goal of discovering all the genetic causes of single ventricle heart defects, we need to analyze the genes of a large number of affected individuals as well as their biological family members. The SOURCE study aims to do that. Ideally, every patient and family in the single ventricle heart community would participate to give us very large numbers of patients and family members to study!<br/><br/>Another difference between the SOURCE study and clinical testing is that SOURCE will store data in a research data repository. This means that the data can be analyzed again and again by many different researchers over time as scientific discoveries advance. New studies may focus on developing novel treatments that target specific genetic variants to either prevent the disease, prevent some of the complications of the disease, or even cure single ventricle heart defects entirely.<br/><br/>A key benefit of participation in SOURCE is the ability to contribute to scientific progress that could help other individuals with single ventricle.`,
              imgStyle: { marginRight: '5px' }
            },
            {
              img: images[7],
              alt: 'FamilyImage',
              question: 'Why is it important to study not just patients, but their family members as well?',
              answer: `By comparing the child’s genome to the parents’ and siblings’ genomes, researchers can more accurately determine which genetic variants are inherited and which are de novo (new). This helps in interpreting the significance of genetic variants.<br/><br/>Genes that cause single ventricle heart defects can be inherited from one parent or both parents, even when those parents do not have congenital heart disease. Sometimes, both parents carry a change in a gene that by itself does not cause single ventricle. However, if a child inherits those variants from both parents, single ventricle will occur. Siblings who are unaffected, meaning they don’t have a heart defect, can help researchers understand what genetic changes run in the family but are not the cause of the single ventricle.`
            },
            {
              img: images[8],
              alt: 'RecycleImage',
              question: 'One of the biggest worries of families and adult patients is whether single ventricle can happen again in their family. What do we know about single ventricle recurring in families?',
              answer: `In a family that has had one child with a single ventricle heart defect, the recurrence risk of some type of congenital heart defect in future children is higher than in the general population. However, the magnitude of that risk depends upon the specific type of single ventricle defect, the specific genes of that individual, and other factors. It is very important for families to consult with a geneticist or genetic counselor, who can provide a more personalized assessment of risk based upon review of their family’s medical history and genetic testing results. For any future pregnancies, parents of a child with single ventricle should have fetal echocardiography to detect congenital heart defects early in pregnancy, allowing for timely diagnosis and planning. In most cases, the likelihood of having another child WITHOUT a congenital heart defect remains high. Even if a heart defect does occur in a subsequent child, it may not be the same or as severe as the condition experienced by the first child.`,
              imgStyle: { marginRight: '5px'},
            },
            {
              img: images[9],
              alt: 'CloudImage',
              question: 'What else do you think is important for patients and families to understand about genetics and single ventricle?',
              answer: `Research into the genetic causes of single ventricle heart defects is changing the landscape of our understanding with breathtaking speed. Studies that include whole genome sequencing, like SOURCE, are needed to identify new causal genes and to understand how multiple genes interact with each other. And, we are only at the beginning of our understandingof how genes interact with the environment in causing single ventricle heart defects, as well as how genes influence the likelihood of patients developing certain long-term complications like heart failure, Fontan-associated liver disease or developmental disabilities.<br/><br/>Different types of technologies have led to better understanding of how to read DNA. We are now able to study genetic activity in individual heart cells during development, which helps us understand which types of cells are most affected by changes in genes and how those changes could lead to single ventricle heart defects. Scientists are now able to edit or change genetic variants in stem cells and in animal models, which helps them understand the specific ways in which changes in genes contribute to or cause single ventricle heart defects.<br/><br/>To summarize, participation in genetic research by individuals and their families affected by single ventricle heart defects helps us achieve a better understanding of the causes of single ventricle and to develop cutting-edge therapies to improve medical outcomes and quality of life for patients.`
            },
            {
              img: images[10],
              alt: 'ContactImage',
              question: 'Where can I learn more about SOURCE?',
              answer: `Visit <a href='http://www.svsource.org' rel='noreferrer' target='_blank'>svsource.org</a> or reach out by email or phone:<ul style="list-style-type:disc;"><li><a href={\`mailto: ${SVSOURCE_CONTACT.EMAIL}\`}>${SVSOURCE_CONTACT.EMAIL}</a></li><li>${SVSOURCE_CONTACT.PHONE}</li></ul>`
            }
          ]} />
        </>
      ),
    },
    {
      alt: 'adn',
      bannerImage: adnBannerImage,
      cardImage: adnCardImage,
      display: true,
      id: 2,
      title:
        'What do we know about the cause of single ventricle and why is it important?',
      description:
        'We don’t fully know why some people are born with single ventricle heart defects – and that’s why we are launching Single Ventricle SOURCE...',
      content: (
        <>
          We don’t fully know why some people are born with single ventricle heart
          defects – and that’s why we are launching{' '}
          <a href='http://www.svsource.org' rel='noreferrer' target='_blank'>
            Single Ventricle SOURCE
          </a>{' '}
          , the world’s largest genetic database of single ventricle patients and
          their families.
          <br />
          <br />
          Here’s what we know:
          <br />
          <br />
          <ul>
            <li>
              <b>There is more than one cause.</b> Single ventricle defects
              include many types of heart problems, affecting both the left and
              right sides of the heart, valves, and other cardiovascular
              structures. Because these develop and function differently, the
              causes of each unique defect are likely to be different.
            </li>
            <li>
              <b>Genetics play a role.</b> Scientists have already found several
              genes that are linked to single ventricle heart defects, but we
              don’t have a clear picture of what role they play in the development
              or severity of the disease.
            </li>
            <li>
              <b>Genetics may not tell the whole story.</b> Sometimes, a genetic
              difference or environmental factor on its own may not result in a
              problem. It is likely that some single ventricle heart defects come
              from a mix of genetic and environmental factors. Environmental
              factors could include things like nutritional deficiencies,
              geography, pollutants, maternal fever, drug exposure, and paternal
              age.
            </li>
          </ul>
          {videoElement}
          <br />
          <br />
          Through SOURCE, participants can share their genetic data (through a
          cheek swab) and medical histories to help researchers across the world
          make new discoveries about the causes of single ventricle. This is
          extremely important to single ventricle patient care and outcomes.&nbsp;
          <b>
            Understanding causes will help pave the way so we can prevent single
            ventricle heart defects from occurring and develop treatments to
            improve patient’s lives.
          </b>
          <ul>
            <li>
              <b>Prevent.</b> By finding out which genes or environmental factors
              cause single ventricle heart defects, we may be able to develop new
              tools or treatments to stop the defect from forming or reduce its
              severity. We also may be able to predict which families are at risk,
              helping doctors give better advice about future pregnancies.
            </li>
            <li>
              <b>Treat.</b> Knowing the causes will help develop and personalize
              treatments for each patient with their unique background and defect.
              This can also help identify who is more likely to develop other
              health problems like liver disease or plastic bronchitis, which can
              lead to improved care and treatment options.
            </li>
          </ul>
          <br />
          <br />
          There isn’t a simple solution for single ventricle. But understanding
          why these heart defects happen and how the disease progresses over time
          will help create better treatments and understand what treatments work
          best at each stage.
          <br />
          <br />
          It&#39;s hard to say exactly how long it will take to find a real cure
          for single ventricle – which might look like preventing the defect from
          happening or creating new care options. Finding a cure usually takes a
          lot of trial and error and may take many years, even decades. In the
          meantime, researchers are working hard to find treatments that make life
          better for patients now as they work towards a cure, and by joining
          studies like SOURCE, you can help.
          <br />
          <br />
          With programs like SOURCE, we hope to create a future with personalized
          treatment plans that prevent or reduce complications, manage symptoms
          better, and improve quality of life. By participating in research
          studies, single ventricle patients and their families can give
          scientists the data they need to make the next big discovery.
          <br />
          <br />
          Find out how you can{' '}
          <a href='http://www.svsource.org' rel='noreferrer' target='_blank'>
            Be the SOURCE
          </a>{' '}
          of new discoveries in single ventricle heart defect research.
          <br />
          <br />
          Looking for more information?{' '}
          <Link to='/welcome/resources/1'>
            Learn what it will take to cure single ventricle.
          </Link>
        </>
      ),
    },
    {
      alt: 'family',
      bannerImage: familyBannerImage,
      cardImage: familyCardImage,
      display: true,
      id: 1,
      title: 'What would it mean to cure single ventricle heart defects?',
      description:
        'Thanks to major advances in surgery, most people born with single ventricle heart defects now survive into adulthood. However, they often face...',
      content: (
        <>
          Thanks to major advances in surgery, most people born with single
          ventricle heart defects now survive into adulthood. However, they often
          face serious complications later in life, such as heart failure and
          liver disease. Currently, there are no treatments that can prevent these
          complications or enable patients to have a normal quality and length of
          their lives.
          <br />
          <br />
          {videoElement2}
          <br />
          <br />
          <b>What will it take to find a cure?</b>
          <br />
          <br />
          A cure for single ventricle heart defects, whether it&#39;s a
          medication, a device, or a combination of both, would allow patients to
          live normal, healthy lives. Right now, there are thousands of
          researchers studying single ventricle heart defects. They each focus on
          different aspects, like why single ventricle heart defects happen and
          why some patients develop certain complications, to better inform
          current care and future treatments. To succeed, we need more research,
          more funding, a lot of patient data (both genetic and clinical), and a
          strong commitment to work together and share our discoveries along the
          way.
          <br />
          <br />
          <b>
            What questions are single ventricle researchers trying to answer to
            find a cure?
          </b>
          <br />
          <br />
          <img
            alt='A heart puzzle with four pieces labeled understand single ventricle causes, understand complications and outcomes, predict and prevent health issues, and develop real cures.'
            src={heartContentImage}
            width='100%'
          />
          <br />
          There is still a lot we don't know about single ventricle, but with
          every new research study that is funded, every journal article that is
          published, and every new tool that is developed, we are one step closer
          to making better treatments available for patients and ultimately
          finding a cure.
          <br />
          <br />
          <b>Where does SOURCE fit in? </b>
          <br />
          <br />
          Single Ventricle SOURCE is a project designed to answer what causes
          single ventricle heart defects and how your unique genetics may increase
          the risk of certain complications. To help answer these questions,
          SOURCE is creating the world’s largest database of single ventricle
          patients and their families. This database includes genetic and medical
          information that can be shared with researchers in a safe, protected way
          that doesn’t identify the participant. That way, the data provided by
          patients and families will be used in many different research studies
          around the world, leading to more discoveries.
          <br />
          <br />
          While SOURCE aims to learn more about what causes single ventricle heart
          defects, this information will also lead to more effective,
          longer-lasting, personalized solutions that improve quality of life for
          patients. This knowledge could be essential to finding cures for single
          ventricle.
          <br />
          <br />
          <b>Ready to get involved?</b> Find out how you can{' '}
          <a href='http://www.svsource.org' rel='noreferrer' target='_blank'>
            Be the SOURCE
          </a>{' '}
          of new discoveries in single ventricle heart defect research.
          <br />
          <br />
          Looking for more information? Learn more about{' '}
          <Link to='/welcome/resources/0'>
            what causes single ventricle and why is it important.
          </Link>
        </>
      ),
    },
    {
      alt: 'summary',
      bannerImage: DoctorBannerImage,
      cardImage: DoctorCardImage,
      display: false,
      id: 0,
      title: 'Summary of: Expert Q&A: Genetics, Single Ventricle, and SOURCE',
      description:
        'This summary is designed to help families understand the key takeaways from Expert...',
      content: (
        <>
          This summary is designed to help families understand the key takeaways from Expert Q&A: Genetics, Single Ventricle, Genetics and SOURCE, with answers from:
          <br />
          <br />
          <b>Jane Newburger, MD, MPH,</b> Associate Chair for Academic Affairs, Department of Cardiology and <b>Amy Roberts, MD,</b> Co-Director, Center for Cardiovascular Genetics, Department of Cardiology, Boston Children’s Hospital; Associate Professor of Pediatrics, Harvard Medical School.
          <br />
          <br />
          For a more detailed explanation, including insights from two leading cardiology experts, read the full Q&A <Link to='/welcome/resources/0'>here.</Link>
          <br/><br/>
          <QASection qa={[
            {
              img: images[0],
              alt: 'HeartImage',
              question: 'What causes single ventricle heart defects?',
              answer: `Single ventricle heart defects happen early in pregnancy. Sometimes, they are caused by changes in a person’s genes. Other times, things like a mom’s health (for example, diabetes or high blood pressure) during pregnancy may play a role. In most cases, we still don’t know the cause of these heart defects.<br/><br/>Research on large numbers of patients will help us learn which genes are involved. That’s what the SOURCE study is trying to do.`
            },
            {
              img: images[1],
              alt: 'LeafImage',
              question: 'Why is the SOURCE study important?',
              answer: `If we understand what causes single ventricle heart defects:<ul style="list-style-type:disc;"><li>Doctors can predict future health problems and treat them earlier.</li><li>Families can learn if the defect might happen again in future children.</li><li>New treatments may be created to help people live longer and healthier lives.</li></ul>`
            },
            {
              img: images[2],
              alt: 'NurseImage',
              question: 'What can genetic testing tell us?',
              answer: `Genetic testing can sometimes find the cause of the heart defect and tell doctors how it might affect other body parts (like hearing or the immune system). But for most people, currently available genetic tests do not find a cause. That is because we don’t yet know all the genes that are involved in single ventricle heart defects. Genetic testing can only test for the genes that we know about.`
            },
            {
              img: images[3],
              alt: 'NoImage',
              question: 'What does a “negative” genetic test mean?',
              answer: `It means doctors didn’t find a known cause in the person’s DNA. This doesn’t mean there isn’t a genetic cause – it just means doctors couldn’t find a gene that is already known to be linked to single ventricle heart defects. But new genes are being discovered all the time. That’s why joining the SOURCE study is important! It looks at much more DNA than genetic tests a doctor might order and could find something new in the future.`
            },
            {
              img: images[5],
              alt: 'DNAImage',
              question: 'How is SOURCE different from regular genetic testing?',
              answer: `Most doctors order tests that check for known gene problems. SOURCE uses whole genome sequencing, which looks at almost all of a person’s DNA — even the parts we don’t fully understand yet. This can help researchers find brand-new causes of single ventricle heart defects.<br/><br/>SOURCE will study many, many people with single ventricle heart defects as well as their family members. Studying lots of people can help make new discoveries.<br/><br/>SOURCE also stores DNA data for future research. That way, as science improves, researchers can learn even more.`
            },
            {
              img: images[7],
              alt: 'FamilyImage',
              question: 'Why does SOURCE study families too?',
              answer: `Looking at DNA from parents and siblings helps scientists see which changes in DNA come from parents and which are new. This helps them figure out which genetic changes may be causing the heart defect.`
            },
            {
              img: images[8],
              alt: 'FamilyImage',
              question: 'Will single ventricle heart defects happen again in the same family?',
              answer: `Families who have one child with a single ventricle defect do have a higher chance than average of having another child with a heart condition — but the chance of having a child WITHOUT a heart defect is still high. It’s best to speak with a genetic counselor to understand your family’s specific risk.`,
              imgStyle: { marginRight: '5px' }
            },
            {
              img: images[6],
              alt: 'HandsImage',
              question: 'Why should patients and families think about joining SOURCE?',
              answer: `Even if you already had genetic testing – no matter the result – participating in SOURCE can help find new genes that cause or contribute to single ventricle heart defects. This can lead to new and better treatments or even cures for patients.`,
              imgStyle: { marginRight: '5px' }
            },
            {
              img: images[10],
              alt: 'ContactImage',
              question: 'Want to learn more?',
              answer: `Visit <a href='http://www.svsource.org' rel='noreferrer' target='_blank'>svsource.org</a> or contact:<ul style="list-style-type:disc;"><li><a href={\`mailto: ${SVSOURCE_CONTACT.EMAIL}\`}>${SVSOURCE_CONTACT.EMAIL}</a></li><li>${SVSOURCE_CONTACT.PHONE}</li></ul>`
            }
          ]} />
        </>
      ),
    },
  ]
};
